export default __webpack_public_path__ + "static/media/mastercard.ce01acf0.svg";